function getInitState() {
  return {
    copySegmentUuid: null,
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  mutations: {
    updateCopySegmentUuid(state, value) {
      state.copySegmentUuid = value
    },
  },

  actions: {},
}
